import { getClient } from '../../apollo';
import { deleteOwnUnsubmittedInteraction as mutation } from '../../graphql/mutation';

export default async function deleteOwnUnsubmittedInteraction(
  id: string
): Promise<boolean> {
  const { data } = await getClient().mutate({
    mutation,
    variables: { id },
  });

  return data.deleteOwnUnsubmittedInteraction;
}
